import { InjectionToken } from '@angular/core';
import { IApiUrl } from '@nibtravel/shared/util/models';
import { SumoLoggerOptions } from 'sumo-logger';

export interface IEnvironment {
  production: boolean;
  fallbackBrand: string;
  stage: string;
}

export interface IEnvironmentV2 extends Record<string, unknown> {
  baseHref?: string | undefined;
  campaignCode?: string;
  cardToken?: IApiUrl;
  contentful?: Record<string, unknown>;
  footprints?: IApiUrl;
  gtm?: string;
  isV2?: boolean;
  kosmos?: IApiUrl;
  partner?: string;
  policies?: IApiUrl;
  production: boolean;
  products?: IApiUrl;
  purchasePath?: string;
  quote?: IApiUrl;
  stage: string;
  sumo?: SumoLoggerOptions;
  theme?: string;
  title?: string;
  users?: IApiUrl;
  tealium?: {
    script: string;
  };
}

/**
 * Injection Token to receive the compilation time Environment variables
 */
export const ENV_VARIABLES = new InjectionToken<IEnvironment | IEnvironmentV2>(
  'ENV_VARIABLES'
);

export interface IWidgetEnvironment extends Record<string, unknown> {
  production: boolean;
  baseHref?: string | undefined;
  contentful?: Record<string, unknown>;
  sumo?: SumoLoggerOptions;
  cota: IEnvironmentV2;
  nibau: IEnvironmentV2;
  nsi: IEnvironmentV2;
  qan: IEnvironmentV2;
  sv: IEnvironmentV2;
  tidau: IEnvironmentV2;
  wn: IEnvironmentV2;
}
